import './Badge.css';
import { ReactNode } from 'react';

type BadgeSize = 'large' | 'medium' | 'small';
type BadgeColor = 'green' | 'blue' | 'orange' | 'grey';

type BadgeProps = { children: ReactNode; color?: BadgeColor; size?: BadgeSize };
export function Badge({ children, color = 'green', size = 'medium' }: BadgeProps) {
	return <div className={'badge ' + size + ' ' + color}>{children}</div>;
}
